// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Pba-z","disabled":"Qba-z","label":"Rba-z"};